import { render } from "./style1.vue?vue&type=template&id=6dbc19a5"
import script from "./style1.vue?vue&type=script&lang=js"
export * from "./style1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__